import {
  StationDashboardModel,
  StationDashboardSubscriptionModel,
  StationDashboardUpdModel,
} from '@/types/channel/station/station.model';
import {numberCommaString} from '@/utils/channel';
import React from 'react';

interface SupportInfoProp {
  fanCount?: StationDashboardUpdModel['fanCount'];
  subscriptionCount?: StationDashboardSubscriptionModel['total'];
  tier1Count?: StationDashboardSubscriptionModel['tier1'];
  tier2Count?: StationDashboardSubscriptionModel['tier2'];
  fanclubCount?: StationDashboardModel['fanclubCount'];
  supporterCount?: StationDashboardModel['supporterCount'];
}
const SupportInfo = ({
  fanCount,
  subscriptionCount,
  tier1Count,
  tier2Count,
  fanclubCount,
  supporterCount,
}: SupportInfoProp) => {
  const SupportInfoData = [
    {label: '애청자 수', value: fanCount},
    {label: '구독팬 수', value: subscriptionCount},
    {label: '베이직', value: tier1Count},
    {label: '플러스', value: tier2Count},
    {label: '팬클럽 수', value: fanclubCount},
    {label: '서포터 수', value: supporterCount},
  ];

  return (
    <>
      <dl>
        <dt>후원 정보</dt>
        {SupportInfoData.map((item, index) => (
          <dd key={index}>
            <strong>{item.label}</strong>
            <b>{numberCommaString(item.value ?? 0)}명</b>
          </dd>
        ))}
      </dl>
    </>
  );
};

export default SupportInfo;
